import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { router } from "@/app/router";
import { applyStoredTheme } from "@/lib/theme";
import "@/styles/brand.css";
import "@/styles/prototype.css";
import "@/styles/mobile.css";
import "@/styles/app.css";

applyStoredTheme();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
